// Angular
import {
  Component,
  OnInit,
  OnDestroy,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';

// rxjs
import { Subscription } from 'rxjs';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';

@Component({
  selector: 'oh-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent implements OnInit, OnDestroy {
  @ViewChild('entry', { read: ViewContainerRef })
  private entry: ViewContainerRef;
  private subscription: Subscription;
  private component: any;
  public state: any;

  constructor(
    private drawerService: DrawerService,
    private resolver: ComponentFactoryResolver,
    private router: Router,
  ) {
    this.state = {};
    this.state.visible = false;
  }

  ngOnInit() {
    this.subscription = this.drawerService.state.subscribe((state: any) => {
      this.state = state;

      if (state.options && state.options.component && state.visible === true) {
        this.component = this.createComponent(state.options.component);
      } else {
        if (!this.component) {
          return;
        }
        this.component.destroy();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('window:keyup', ['$event'])
  private dismissViaEscape(event) {
    if (event.which === 27) {
      this.dismiss();
    }
  }

  private createComponent(component: any) {
    const factory = this.resolver.resolveComponentFactory(component);
    return this.entry.createComponent(factory);
  }

  public dismiss() {
    if (this.state.options && this.state.options.locked === true) {
      return;
    }
    this.router.navigate([]);
    this.drawerService.dismiss();
  }
}
